import React from 'react';
import { observer } from 'mobx-react';
import Navigation from 'components/navigation';
import { AppUI } from '@seedlang/state';
import withRouteParams from 'utils/with_route_params';
import { Outlet } from 'react-router-dom';

@observer
class Classroom extends React.Component {

  render() {
    return (
      <div className='builder'>
        <Navigation
          currentRoute={AppUI.routeStore.routeName}
          links={[
            {
              link: 'classroom.students',
              title: 'Students',
              params: {groupId: this.props.params.groupId},
            },
            {
              link: 'classroom.settings',
              title: 'Settings',
              params: {groupId: this.props.params.groupId},
            },
          ]}
        />
        <Outlet />
      </div>
    );
  }
}

export default withRouteParams(Classroom);
